import { MARKET_UI, type MarketCode } from '@/lib/market'

export const LOCALES = ['es', 'pt', 'en'] as const
export type Locale = (typeof LOCALES)[number]

export function isLocale(value: unknown): value is Locale {
  return typeof value === 'string' && (LOCALES as readonly string[]).includes(value)
}

export function detectLocale(stored: unknown, market: MarketCode): Locale {
  return isLocale(stored) ? stored : MARKET_UI[market].locale
}
